import { useI18n } from "../i18n.jsx";
import { usePlus } from "../plus/PlusProvider.jsx";

export default function PlusUpgradePanel({
  compact = false,
  source = "upgrade-panel",
  title = null,
  copy = null
}) {
  const plus = usePlus();
  const { t } = useI18n();
  const monthly = plus.plusPlans.monthly;
  const yearly = plus.plusPlans.yearly;
  const showRenewal = plus.canRenewPlus;
  const showPlanOptions = !plus.isPlus || showRenewal;
  const activeCopy = showRenewal
    ? plus.currentPeriodEndLabel
      ? t("plus.canceledUntil", { date: plus.currentPeriodEndLabel })
      : t("plus.canceledCopy")
    : t("plus.activeCopy");
  const upgradeTitle = title || t("plus.upgradeTitle");
  const upgradeCopy = copy || t("plus.upgradeCopy");

  return (
    <section className={compact ? "plus-upgrade-panel is-compact" : "plus-upgrade-panel"} aria-label={t("plus.upgradeLabel")}>
      <div className="plus-upgrade-copy">
        <p className="kicker">SielpA Plus</p>
        <h3>{showRenewal ? t("plus.renewTitle") : plus.isPlus ? t("plus.activeTitle") : upgradeTitle}</h3>
        <p>{plus.isPlus ? activeCopy : upgradeCopy}</p>
      </div>

      {!compact ? (
        <div className="plus-upgrade-feature-list" aria-label={t("plus.featuresLabel")}>
          <span>{t("plus.noAds")}</span>
          <span>{t("plus.premiumVoice")}</span>
          <span>{t("plus.vocabBurst")}</span>
        </div>
      ) : null}

      <div className="plus-plan-actions">
        {!showPlanOptions ? (
          <button className="primary-button" type="button" disabled={plus.billingBusy} onClick={() => plus.openCustomerPortal({ source })}>
            {plus.billingBusy ? t("plus.opening") : t("plus.manage")}
          </button>
        ) : (
          <>
            <button className="primary-button" type="button" disabled={plus.billingBusy} onClick={() => plus.startCheckout("monthly", { source })}>
              {plus.billingBusy ? t("plus.opening") : `${showRenewal ? t("plus.renewPrefix") : ""}${monthly.label} - ${monthly.price}`}
            </button>
            <button className="secondary-button" type="button" disabled={plus.billingBusy} onClick={() => plus.startCheckout("yearly", { source })}>
              {`${showRenewal ? t("plus.renewPrefix") : ""}${yearly.label} - ${yearly.price}`}
            </button>
          </>
        )}
      </div>

      {plus.billingError ? <p className="plus-status-message is-error" role="alert">{plus.billingError}</p> : null}
      {plus.billingNotice ? <p className="plus-status-message" role="status">{plus.billingNotice}</p> : null}
    </section>
  );
}
